/**
 * View for bulk Deviations are for all deviations coming from Bulk Cargo Request.
 */

var VRC = VRC || {};

VRC.BulkDeviationView = (function(){

  var _queries = {
    container : '#bulk-state-deviation'
  };

  var init = function(){
    var ctx = {};
    render(ctx);
    attachModal();
  };

  var attachDraggable = function(){

    var $deviationArea = $(".bulk_deck.deviation-area");

    interact(".bulk_deck.deviation-area").dropzone({
      accept: ".main, .request",
      ondropactivate: function () {
        // add active dropzone feedback
        $deviationArea.addClass("can-drop");
      },
      ondragenter: function (event) {
        var dropzoneElement = $(event.target);

        // feedback the possibility of a drop
        dropzoneElement.addClass("drop-target");
      },
      ondragleave: function (event) {
        var dropzoneElement = $(event.target);

        // remove the drop feedback style
        dropzoneElement.removeClass("drop-target");
      },
      ondrop: function (event) {
        var $draggableElement = $(event.relatedTarget);
        var $droppable = $(event.target);

        var isLoading = $draggableElement.hasClass('request');

        if(isLoading){
          var containerId = $draggableElement.attr('data-container-id');
          var request = VRC.BulkCargoRequestManager.getBulkCargoRequestById(containerId);
          showModal($droppable, request.toJson());
        }

        else{
          var bulkTankId = $draggableElement.attr('data-bulk-tank-id');
          var bulkTank = VRC.BulkTankManager.getBulkTankById(bulkTankId);
          var offloadableContent = bulkTank.getOffloadableContent();
          if(offloadableContent.length > 1){
            showSelectCargoId($droppable, offloadableContent)
          }
          else{
            showModal($droppable, offloadableContent[0]);
          }
        }
        $deviationArea.removeClass("can-drop");
      },
      ondropdeactivate: function () {
        $deviationArea.removeClass("can-drop");
      }
    });
  };

  var showSelectCargoId = function ($placeHolder, content) {
    var popOverHtml = WELL.Handlebars.VRC.offload_action_selector({
      units: VRC.MasterDataService.getBulkValueUnitsAsArray(),
      content : content
    });

    $placeHolder.attr('data-content', popOverHtml);
    $placeHolder.popover({html: true,  placement: 'left auto', sanitize: false });
    $placeHolder.popover('show');

    var $popover =  $placeHolder.next();
    var $cargoItemsBtn = $popover.find('.offload-popup__cargo-list__btns');
    var $cancelBtn = $popover.find('.bulk-offload-cancel');

    $cargoItemsBtn.click(function (e) {
      e.preventDefault();

      var $btn = $(this);
      $btn.prop('disabled', true);

      var containerId = $btn.attr('data-container-id');
      if(!containerId){
        containerId = "undefined";
      }

      var bulkTankCargoItem  = _.findWhere(content, {containerId : containerId});
      showModal($placeHolder, bulkTankCargoItem)
    });

    $cancelBtn.click(function(e){
      e.preventDefault();
      $placeHolder.popover('destroy');
      $placeHolder.remove();
    });
  };

  var showModal = function ($dropzoneElement, droppedElement) {
    if(!droppedElement){
      return;
    }

    var onConfirm = function($dropzoneElement, inputElements, json){
        addDeviation(inputElements, json);
        $dropzoneElement.popover('destroy');
    };

    var config = {};
    if(!droppedElement.bulkTankId){
      config.action = 'cargo_to_dev';
    }

    VRC.BulkLoadingPopoverView.show($dropzoneElement, droppedElement, onConfirm, null, config)
  };

  var attachModal = function(){
    $(".bulk_deck.deviation-area")
      .on('click', function (e) {

        var bulkTank = VRC.SpecialBulkTanks.getDeviationTank();
        VRC.BulkModalView.render(bulkTank.getBulkTankId(), {isSpecialTank : true});
      });
  };


  var addOffloadDeviation = function (json, date, qty, inputRemarks) {
    var bulkTank = VRC.BulkTankManager.getBulkTankById(json.bulkTankId);
    var lastContainerAction = bulkTank.getLatestContentByContainerId(json.containerId);
    var voyageBulk = VRC.VoyageBulk(lastContainerAction.toJson());

    voyageBulk.createNewId();
    voyageBulk.setAction(g_actions.deviation);
    voyageBulk.setDate(date);
    voyageBulk.setValueQty(qty);
    voyageBulk.setRemarks(inputRemarks);
    bulkTank.addContent(voyageBulk);
    VRC.BulkStateView.renderTank(bulkTank);

  };
  var addLoadingDeviation = function (json, date, qty, qtyRob, inputRemarks) {
    var voyageBulk = VRC.VoyageBulk();
    var bulkCargoRequest = VRC.BulkCargoRequestManager.getBulkCargoRequestById(json.containerId);
    var bulkTank = VRC.SpecialBulkTanks.getDeviationTank();

    voyageBulk.parseFromBulkRequest(bulkCargoRequest, bulkTank, qty, qtyRob, date, inputRemarks);
    voyageBulk.setAction(g_actions.deviation);
    bulkCargoRequest.subtractValueQty(qty);
    bulkTank.addContent(voyageBulk);
    VRC.BulkLoadingAreaView.reRenderBulkRequest(bulkCargoRequest);
  };

  var addDeviation = function (inputElements, json) {
    var qty = VRC.Utils.Number.parseFloat(inputElements.$valueQty.val()) || 0;
    var qtyRob = VRC.Utils.Number.parseFloat(inputElements.$qtyRob.val()) || 0;
    var date = inputElements.$date.val();
    var inputRemarks = inputElements.$remarkField.val();

    if(json.bulkTankId) {
      addOffloadDeviation(json, date, qty, inputRemarks);
    }
    else{
      addLoadingDeviation(json, date, qty, qtyRob,inputRemarks);
    }

  };

  var render = function(context) {
    var $container = $(_queries.container);
    var content = WELL.Handlebars.VRC.bulk_deviation_area(context);
    $container.html(content);
    attachDraggable();
  };

  return {
    init : init,
    render : render
  }
})();
